<template>
  <div class>
    <v-expansion-panel popout light>
      <v-expansion-panel-content>
        <template slot="header">
          <h4 class="earth-color">GLOBAL SEARCH</h4>
        </template>
        <template slot="actions">
          <v-icon color="primary">$vuetify.icons.expand</v-icon>
        </template>

        <v-card flat class="col-lg-12 col-lg-offset-1">
          <div class="hpanel">
            <div class="col-lg-12">
              <div class="hpanel">
                <div class="panel-body">
                  <v-layout row wrap>
                    <v-flex lg6 m6 sm12 xs12>
                      <div class="m-t-sm">
                        <v-form @submit.prevent="searchTerm()">
                          <h6 class="earth">KEYWORD SEARCH</h6>
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm10 xs10>
                              <v-container>
                                <v-text-field
                                  label="Search by: Name, Email"
                                  v-model="term.key"
                                  required
                                >
                                </v-text-field>
                              </v-container>
                            </v-flex>
                            <v-flex lg4 md4 sm12 xs12>
                              <v-container fluid>
                                <v-btn
                                  :depressed="true"
                                  color="info"
                                  type="submit"
                                >
                                  <i class="fa fa-search"></i>
                                </v-btn>
                                <v-btn
                                  :depressed="true"
                                  color="error"
                                  @click="reset()"
                                  >Reset</v-btn
                                >
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </div>
                    </v-flex>
                    <v-flex lg6 m6 sm12 xs12>
                      <div class="m-t-sm">
                        <v-form @submit.prevent="searchRange()">
                          <h6 class="earth">Search By Creation Date</h6>

                          <v-layout row wrap>
                            <v-flex lg4 md4 sm4 xs12>
                              <v-container>
                                <v-dialog
                                  ref="dialog"
                                  persistent
                                  v-model="modal1"
                                  lazy
                                  full-width
                                  width="290px"
                                  :return-value.sync="range.start_date"
                                >
                                  <v-text-field
                                    slot="activator"
                                    label="Start Date"
                                    v-model="range.start_date"
                                    readonly
                                  ></v-text-field>
                                  <v-date-picker
                                    v-model="range.start_date"
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      :depressed="true"
                                      flat
                                      color="primary"
                                      @click="modal1 = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      :depressed="true"
                                      flat
                                      color="primary"
                                      @click="
                                        $refs.dialog.save(range.start_date)
                                      "
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-dialog>
                              </v-container>
                            </v-flex>
                            <v-flex lg4 md4 sm4xs12>
                              <v-container>
                                <v-dialog
                                  ref="dialog1"
                                  persistent
                                  v-model="modal2"
                                  lazy
                                  full-width
                                  width="290px"
                                  :return-value.sync="range.end_date"
                                >
                                  <v-text-field
                                    slot="activator"
                                    label="End Date"
                                    v-model="range.end_date"
                                    readonly
                                  ></v-text-field>
                                  <v-date-picker
                                    v-model="range.end_date"
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      :depressed="true"
                                      flat
                                      color="primary"
                                      @click="modal2 = false"
                                      >Cancel</v-btn
                                    >
                                    <v-btn
                                      :depressed="true"
                                      flat
                                      color="primary"
                                      @click="
                                        $refs.dialog1.save(range.end_date)
                                      "
                                      >OK</v-btn
                                    >
                                  </v-date-picker>
                                </v-dialog>
                              </v-container>
                            </v-flex>

                            <v-flex lg4 md4 sm12 xs12>
                              <v-container fluid>
                                <v-btn
                                  :depressed="true"
                                  color="info"
                                  type="submit"
                                >
                                  <i class="fa fa-search"></i>
                                </v-btn>
                                <v-btn
                                  :depressed="true"
                                  color="error"
                                  @click="reset()"
                                  >Reset</v-btn
                                >
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <br />
    <v-card flat>
      <v-card-title>
        <h4 class="earth-color">ALL PUBLIC USERS</h4>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          text="Search"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="$allBookingUsers"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
      >
        <v-progress-linear
          slot="progress"
          color="primary"
          indeterminate
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.full_name }}</td>
          <td>{{ props.item.email }}</td>

          <td>{{ formated_date(props.item.registered_on) }}</td>
          <td
            v-if="props.item.active_status === 'Active'"
            style="background-color: #44bd32"
          >
            {{ props.item.active_status }}
          </td>
          <td
            v-if="props.item.active_status === 'Suspended'"
            style="background-color: #fbc531"
          >
            {{ props.item.active_status }}
          </td>
          <td>
            <v-btn
              :depressed="true"
              small
              @click="openUser(props.item.booking_user_public_id)"
              >View User</v-btn
            >
          </td>
        </template>
        <template slot="footer">
          <td :colspan="columns.length">
            <vue-json-to-csv
              :json-data="$allBookingUsers"
              csv-title="Public Users List"
              :labels="{
                registered_on: { title: 'Created At' },
                full_name: { title: 'Name' },
                email: { title: 'Email' },
                active_status: { title: 'Active Status' },
              }"
            >
              <v-btn class="">
                <b>Download CSV</b>
              </v-btn>
            </vue-json-to-csv>
          </td>
          <td></td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>

      <div>
        <v-btn
          :depressed="true"
          @click="getMore()"
          color="info"
          :loading="this.$store.state.LoadingStore.loading"
          >GET MORE</v-btn
        >
        <v-btn
          :depressed="true"
          @click="getAllUsers()"
          color="default"
          :loading="this.$store.state.LoadingStore.loading"
          >GET ALL</v-btn
        >
      </div>
    </v-card>
  </div>
</template>
  
  <script>
import VueJsonToCsv from "vue-json-to-csv";
export default {
  components: { VueJsonToCsv },
  data() {
    return {
      localData: JSON.parse(localStorage.getItem("unem")),
      search: "",
      page: 2,
      term: {
        key: "",
      },
      range: {
        start_date: "",
        end_date: "",
        date_search: "0",
        alert_type: "",
      },
	  modal1: false,
      modal2: false,
      columns: [
        {
          text: "Name",
          value: "full_name",
        },
        {
          text: "Email",
          value: "email",
        },

        {
          text: "Added On",
          value: "created_at",
        },
        {
          text: "Status",
          value: "active_status",
        },
        {
          text: "Action",
          value: "",
        },
      ],
    };
  },
  methods: {
    openUser: function (publicId) {
      this.$router.push({
        name: "PublicUser",
        params: {
          public_user_id: publicId,
        },
      });
    },
    getMore() {
      this.loading = true;

      if (this.page === 2) {
        this.$store.dispatch("get_more_users", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_users", this.page);
        this.page = this.page + 1;
      }
    },
    getAllUsers() {
      this.loading = true;
      let page = 0;
      this.$store.dispatch("get_more_users", page);
    },
  },
  created() {
    this.$store.dispatch("get_all_booking_users");
  },
};
</script>
  
  <style>
</style>
  